import apiClient from '@shared/config/axiosConfig';

// Error Logs API
export const errorLogsAPI = {
  // Obtener todos los logs de errores con filtros
  getErrorLogs: (filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });

    const queryString = params.toString();
    return apiClient.get(`/error-logs${queryString ? `?${queryString}` : ''}`);
  },

  // Obtener un log de error específico
  getErrorLogById: (id) => {
    return apiClient.get(`/error-logs/${id}`);
  },

  // Obtener estadísticas de errores
  getErrorStats: (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    const queryString = params.toString();
    return apiClient.get(`/error-logs/stats${queryString ? `?${queryString}` : ''}`);
  },

  // Crear un log de error manualmente (para pruebas — requiere auth)
  createErrorLog: (errorData) => {
    return apiClient.post('/error-logs', errorData, {
      skipErrorLog: true,
    });
  },

  // Reportar errores del frontend — sin auth estricto, siempre funciona
  createFrontendErrorLog: (errorData) => {
    return apiClient.post('/error-logs/frontend', errorData, {
      skipErrorLog: true,
    });
  },

  // Limpiar logs antiguos
  cleanOldLogs: (daysToKeep = 30) => {
    return apiClient.delete('/error-logs/clean', { data: { daysToKeep } });
  },

  // Estadísticas consolidadas para el Developer Dashboard
  getDashboardStats: () => {
    return apiClient.get('/error-logs/dashboard', { skipErrorLog: true });
  },
};

export default errorLogsAPI;
